import React, { useContext, useEffect, useMemo, useState } from "react"
import { NewsContext, LanguageContext } from "../context"
import moment from "moment"
import { DATE_FORMAT } from "../utils/constants"
import { Link, useParams } from "react-router-dom"


const NewsDetail = () => {
  const { news = [], newsLoaded, newsCategories = [], newsCategoriesLoaded } = useContext(NewsContext)
  const { t, localizedProperty, currentLocale } = useContext(LanguageContext)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const params = useParams()

  const newsId = params.id

  const isLoading = !newsLoaded

  const newsItem = useMemo(() => {
    return news.find((item) => item.id === newsId)
  }, [news, newsId])

  const title = localizedProperty(newsItem, "title")
  const subtitle = localizedProperty(newsItem, "subtitle")
  const date = moment(newsItem?.date, 'YYYY-MM-DD')
  const formattedDate = date ? date.format(DATE_FORMAT) : ""
  // const categoryLabel = deriveNewsCategoryLabel(newsItem, languages, categoriesLookup)
  const imageUrl = newsItem?.image?.url
  const imageAlt = newsItem?.image?.caption || localizedProperty(newsItem, "title")

  return (
    <div className="news-page relative">
      {isLoading && (
        <div className="global-loading">
          <div className="global-loading__background" />
          <div className="global-loading__spinner" />
        </div>
      )}

      {!isLoading && !newsItem && (
        <div className="content-parent">
          <h4 className="event-title !text-center">{t('generic.not_found')}</h4>
          <div className="mt-6 flex justify-center">
            <Link to="/"><button className="btn">{t('generic.return_to_home')}</button></Link>
          </div>
        </div>
      )}

      {!isLoading && newsItem && (<div className="content-parent news-page__container">
        <div className="news-card__body">
          <h2 className="news-card__title">{title}</h2>
          {formattedDate && <p className="news-card__date">{formattedDate}</p>}
          {subtitle && <p className="news-card__subtitle">{subtitle}</p>}
          <div className="news-card__tags">
            {newsItem.categories?.map((categoryId) => {
              const category = newsCategories.find((cat) => cat.id === categoryId)
              if (!category) {
                return null
              }
              const categoryLabel = localizedProperty(category, "name")
              return categoryLabel ? (
                <span key={categoryId} className="news-card__tag">{categoryLabel}</span>
              ) : null
            })}
          </div>
          {imageUrl && (
            <img className="news-detail__image" src={imageUrl} alt={imageAlt} loading="lazy" />
          )}
          {/* <div className="news-detail__content" dangerouslySetInnerHTML={{ __html: newsItem ? newsItem.content[currentLocale] : "" }}> */}
          <div className="news-detail__text" dangerouslySetInnerHTML={{ __html: localizedProperty(newsItem, "description") }} />
          {localizedProperty(newsItem, "links") && localizedProperty(newsItem, "links").map((link, index) => {
            return <div key={index} className="news-detail__link">
              <a href={link} target="_blank" rel="noopener noreferrer">
                {link}
              </a>
            </div>
          })}
        </div>
      </div>)}
    </div>
  )
}

export default NewsDetail
